import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { IntegrateState } from '../state/integrate_state';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app_state';

@Component({
  selector: 'yi-testimonial-1',
  template: require('./testimonial1.component.html'),
  styles: [require('./testimonial.component.scss')]
})
export class Testimonial1Component {

  constructor(private store: Store<IAppState>) {
  }
  isShopify2(): Observable<boolean> {
    return this.store.select(state => state.app.install.integrate).map((state: IntegrateState) => {
      return !!state.shopifyDeeplink;
    });
  }
}
